import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import vuetify from './plugins/vuetify'
import VueMqtt from 'vue-mqtt'
import VueNetworkChecker from '@/components/VueNetworkChecker'
import DashboardPlugin from "./plugins/dashboard-plugin";
import VueGauge from 'vue-gauge';

import axios from 'axios'
import auth from '@/services/auth'
import api from '@/services/api'
import config from '@/services/api_config'
import VuetifyConfirm from 'vuetify-confirm'
import JsonCSV from 'vue-json-csv'

import i18n from "./i18n";

Vue.prototype.$http = axios
Vue.prototype.$api = api
Vue.prototype.$cfg = {
  nstda: false
}
var promise = auth.checkLogin()

promise.then(function (result) {
  var option = {
    keepalive: 30,
    clientId: 'vuejs_test_' + Math.random().toString(16).substr(2, 8),
    username: config.MQTT_USER,
    password: config.MQTT_PASSWORD,
    port: config.MQTT_PORT,
    path: '/mqtt'
  }
  //Vue.use(VueMqtt, 'ws://167.71.223.60', option)
  // Vue.use(VueMqtt, 'ws://27.254.140.96', option)
  Vue.use(VueMqtt, config.MQTT_URL, option)
  Vue.component('downloadCsv', JsonCSV)
  Vue.use(DashboardPlugin)
  Vue.component('vue-gauge', VueGauge);

  Vue.prototype.$auth = auth
  Vue.config.productionTip = false
  axios.defaults.headers = {
    'Content-Type': 'application/json; charset=utf-8',
    'x-token': auth.getToken(),
  }
  Vue.component('VueInternetChecker', VueNetworkChecker)
  Vue.use(VuetifyConfirm, {
    vuetify,
    buttonTrueText: 'ตกลง',
    buttonFalseText: 'ยกเลิก',
  })
  new Vue({
    router,
    vuetify,
    i18n,
    render: h => h(App)
  }).$mount('#app')
})

